function clipboardSuccess() {
	console.log("复制成功");
}

function clipboardError() {
	console.log("复制失败");
}

export function copySync(text) {
	if (!import.meta.client || !text) return false;

	const textarea = document.createElement("textarea");
	textarea.value = text;
	textarea.setAttribute("readonly", "");
	textarea.style.cssText =
		"position:fixed;top:0;left:0;width:2px;height:2px;padding:0;border:none;outline:none;opacity:0;z-index:-1;";
	document.body.appendChild(textarea);

	let copied = false;
	try {
		textarea.focus({ preventScroll: true });
		textarea.select();
		textarea.setSelectionRange(0, text.length);
		copied = document.execCommand("copy");
	} catch (error) {
		console.warn("同步复制失败:", error);
	} finally {
		document.body.removeChild(textarea);
	}

	return copied;
}

/**
 * @copytext 复制的文本
 * @event 事件对象 (已废弃，保留兼容性)
 * @onSuccess 复制成功的回调函数
 * @onError 复制失败的回调函数
 */
export async function copy(copytext, event, onSuccess, onError) {
	if (!import.meta.client) {
		console.warn("复制功能仅在客户端可用");
		return;
	}

	if (copySync(copytext)) {
		onSuccess ? onSuccess() : clipboardSuccess();
		return;
	}

	try {
		if (navigator.clipboard?.writeText) {
			await navigator.clipboard.writeText(copytext);
			onSuccess ? onSuccess() : clipboardSuccess();
			return;
		}
	} catch (error) {
		console.warn("Clipboard API 复制失败:", error);
	}

	onError ? onError() : clipboardError();
}
